import { Navigate } from "react-router-dom";
import { useMemberstack } from "@/lib/memberstack";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useMemberstack();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="weave-spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
